import React, { Component } from 'react';
import Configuration from '../../Configuration.js';

class VisitCarrierDetails extends Component {
  render(){
    return (
      <div className="visit-details-wrapper">
        <div className="visit-details d-flex flex-column">
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Folio:</h6>
            <span className="text-muted">#{this.props.visit.folio}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Detalles:</h6>
            <span className="text-muted">{this.props.visit.details}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Transportista:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.carrier.name}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Conductor:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.driver.name}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Tipo de Camión:</h6>
            <span className="text-muted">
              {this.props.visit.visit_kind.visit_ticket.truck_kind.name} 
            </span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Placas:</h6>
            <span className="text-muted">
              {this.props.visit.visit_kind.visit_ticket.truck.plates} 
            </span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Status:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.status}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Peso de entrada:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.start_weight}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Peso de salida:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.end_weight}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Exceso de peso:</h6>
            <span className="text-muted">{this.props.visit.visit_kind.visit_ticket.excess}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Usuario que autoiza:</h6>
            <span className="text-muted">{this.props.visit.profile.names}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de programada:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.due_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de llegada:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.arrive_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de salida:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.leave_date)}</span>
          </div> 
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Tiempo de permanencia:</h6>
            <span className="text-muted">{Configuration.stayTime(this.props.visit.arrive_date, this.props.visit.leave_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Usuario de creación:</h6>
            <span className="text-muted">{this.props.visit.profile.names}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default VisitCarrierDetails;



// WEBPACK FOOTER //
// ./src/components/access/VisitCarrierDetails.js